import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { LocalCorridorService } from '../proxy/planning/controllers/local-corridor.service';

FieldBuilder.setNamespace('Planning');

export const LOCALROAD_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.LocalRoad.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .foreignKey('localCorridorId', 'Entity.LocalCorridor', LocalCorridorService)
    .displayFromNested('localCorridor.name')
    .sortBy('localCorridor.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const LOCALROAD_CONFIG = {
  entityName: 'LocalRoad',
  localizationKey: 'Planning::Entity.LocalRoad',
  permission: 'GeneralLocations.LocalRoads',
  fields: LOCALROAD_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Locations + MENU_NAME_SUFFIX,
};
